'use client';
import React from 'react';
import styles from './BookingInfoSkeleton.module.css';

const BookingInfoSkeleton = () => {
  return (
    <div className={styles.booking_info}>
      {/* Skeleton title */}
      <div className={styles.skeleton_title}></div>

      {/* Skeleton timezone */}
      <div className={styles.skeleton_timezone}></div>

      {/* Skeleton rating info */}
      <div className={styles.skeleton_info_item}>
        <div className={styles.skeleton_icon}></div>
        <div className={styles.skeleton_rating_text}></div>
        <div className={styles.skeleton_sessions_text}></div>
      </div>

      {/* Skeleton price info */}
      <div className={styles.skeleton_info_item}>
        <div className={styles.skeleton_icon}></div>
        <div className={styles.skeleton_price_text}></div>
        <div className={styles.skeleton_duration_text}></div>
        <div className={styles.skeleton_change_duration}></div>
      </div>
    </div>
  );
};

export default BookingInfoSkeleton;
